// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setModuleConfigMap = createAction('[Custom PDF Report Builder] Set Module Config Map', props());
